import { Fragment } from 'react';

import { Outlet } from 'react-router-dom';

import { TitleManager } from '@/components/app';
import { loginRoute } from '@/features/authentication/features/login';
import { signupRoute } from '@/features/authentication/features/signup';
import { subscriptionRoute } from '@/features/authentication/features/subscription';
import { homeRoute } from '@/features/home';
import { sentryCreateBrowserRouter } from '@/lib';

import { mainSettingsRoute } from './main-settings-route';
import { notFoundRoute } from './not-found-route';
import { subscriptionReturnRoute } from './subscription-return-route';

const RootLayout = () => (
  <Fragment>
    <TitleManager />
    <Outlet />
  </Fragment>
);

export const router = sentryCreateBrowserRouter(
  [
    {
      path: '/',
      element: <RootLayout />,
      children: [
        loginRoute,
        signupRoute,
        subscriptionRoute,
        subscriptionReturnRoute,
        homeRoute,
        mainSettingsRoute,
        notFoundRoute,
      ],
    },
  ],
  { basename: ENV.BASE_PUBLIC_PATH },
);
